import React, { useState } from "react";
import { IMaskInput } from "react-imask";
import { InputBaseComponentProps } from "@mui/material/InputBase";

// TODO combine this with ThousandsNumberInputFloat
// these are only separate because its hard or impossible to pass props from NumberFieldConfigured to the inputComponent
export const ThousandsNumberInputFloatScaleThree = React.forwardRef<HTMLInputElement, InputBaseComponentProps>(
  function ThousandsNumberInput(props, ref) {
    const { onChange, name, numberType, onBlur, ...other }: any = props;
    const [trackedCurrentValue, setTrackedCurrentValue] = useState(other.value);
    const internalOnBlur = () => {
      //otherwise the onBlur triggers with the masked value (for example 7.120 instead of 7120)
      onBlur({ target: { name: name, value: trackedCurrentValue } });
    };

    return (
      <IMaskInput
        {...other}
        mask={Number}
        scale={3}
        radix={","}
        onBlur={internalOnBlur}
        unmask
        thousandsSeparator={"."}
        inputRef={ref}
        onPaste={(event) => {
          event.preventDefault();
          onChange({
            target: { name: name, value: event.clipboardData.getData("text").replace(/\./g, "").replace(",", ".") },
          });
        }}
        onAccept={(value) => {
          setTrackedCurrentValue(value);
          onChange({ target: { name: name, value } });
        }}
      />
    );
  },
);
